import { render, staticRenderFns } from "./ProjectDetailView.vue?vue&type=template&id=ff3e0756&scoped=true&"
import script from "./ProjectDetailView.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetailView.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetailView.vue?vue&type=style&index=0&id=ff3e0756&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3e0756",
  null
  
)

export default component.exports